import Vue from 'vue'
import Vuex from 'vuex'
import menu from './menu'
import auth from './auth'
import snackbar from './snackbar'
import data from './data'
import filter from './filter'

Vue.use(Vuex)

Vue.config.devtools = true;

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    menu,
    auth,
    snackbar,
    data,
    filter
  }
})
